import React from "react";
import "../styles/Paramedical.css";

const paramedicalCourses = [
  {
    src: "/DMLTimage1.webp",
    alt: "DMLT Paramedical",
    heading: "DMLT (Diploma in Medical Laboratory Technology)",
    institution: "Sarojini Institute, Dhule",
    info: "Comprehensive training in clinical laboratory techniques and medical diagnostics, preparing for essential roles in healthcare laboratories."
  },
  {
    src: "/Physiotherapyphoto1.webp",
    alt: "Physiotherapy",
    heading: "Physiotherapy",
    institution: "Sarojini Institute, Dhule",
    info: "Prepares students for careers in rehabilitation and physical therapy, focusing on patient mobility, recovery, and modern therapeutic practices."
  }
];

function Paramedical() {
  return (
    <div className="paramedical-main">
      <div className="paramedical-container">
        <h1>Paramedical Courses</h1>
        <div className="paramedical-list">
          {paramedicalCourses.map((course, idx) => (
            <div className="paramedical-card" key={idx}>
              <img src={course.src} alt={course.alt} className="paramedical-img" />
              <div className="paramedical-info">
                <div className="paramedical-heading">{course.heading}</div>
                <div className="paramedical-inst">{course.institution}</div>
                <div className="paramedical-desc">{course.info}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <a href="/apply?course=Paramedical" className="paramedical-apply-btn">
            Apply for Paramedical Course
          </a>
        </div>
      </div>
    </div>
  );
}

export default Paramedical;